module.exports = __webpack_public_path__ + "static/media/47.8594d6fd.JPG";